import {Chart} from 'chart.js';

export default class PieChart {
    private chart: Chart<'doughnut'>;

    public constructor(
        element: HTMLCanvasElement,
        dataset: PieChartDataSet,
        labels: string[],
    ) {
        this.chart = new Chart(
            element,
            {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            ...dataset,
                            borderColor: '#fff',
                            borderWidth: 2,
                            hoverOffset: 8,
                        },
                    ],
                    labels,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    cutout: '68%',
                    layout: {
                        // room for the hover offset, otherwise slices get clipped
                        padding: 8,
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: item => {
                                    const values = item.dataset.data as number[];
                                    const total = values.reduce((carry, value) => carry + value, 0);
                                    const share = total > 0 ? Math.round((item.parsed / total) * 100) : 0;

                                    return ` ${item.label}: ${item.parsed} (${share} %)`;
                                },
                            },
                        },
                    },
                },
            },
        );
    }
}

export interface PieChartDataSet {
    data: number[];
    backgroundColor: string;
}
